import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ModalState} from "../../../types/modals";


export type SectionOrderModalState = ModalState & {
    languageTab: string
}

const initialState: SectionOrderModalState = {
    loading: false,
    isOpen: false,
    languageTab: '',
    error: null,
}

type SectionOrderModalPayload = {
    language: string
}

const slice = createSlice({
    name: 'sectionOrderModal',
    initialState,
    reducers: {
        openSectionOrderModal: (state, action: PayloadAction<SectionOrderModalPayload>) => {
            state.isOpen = true;
            state.languageTab = action.payload.language;
        },
        closeSectionOrderModal: () => {
            return initialState;
        },
    },
});

export const {
    openSectionOrderModal,
    closeSectionOrderModal,
} = slice.actions;

export default slice.reducer;